<template>
    <div class="scroll-wrap" ref="scrollWrap">
        <div ref="scrollView" :class="['scroll-view']" @scroll="scrollHandler">
            <div class="view-wrap" ref="viewWrap">
                <slot></slot>
            </div>
        </div>
        <Bar axis="y" :initial-move="yTop" :initial-size="yHeight"></Bar>
        <Bar axis="x" :initial-move="xLeft" :initial-size="xWidth"></Bar>
    </div>
</template>
<script>
    import Bar from './scroll-bar.vue'
    import throttle from 'lodash.throttle'

    export default {
        name: "scroll-wrap",
        components: {
            Bar
        },
        data() {
            return {
                yHeight: 2,
                yTop: 0,
                xWidth: 0,
                xLeft: 0,
                down: false,
                mouse: {
                    x: 0,
                    y: 0,
                }
            }
        },
        computed: {
            scrollWrap() {
                return this.$refs['scrollWrap']
            },
            scrollView() {
                return this.$refs['scrollView']
            },
            viewWrap() {
                return this.$refs['viewWrap']
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.update();
                new ResizeObserver(() => {
                    this.update()
                }).observe(this.viewWrap)
                new ResizeObserver(() => {
                    this.update()
                }).observe(this.scrollWrap)
            })
        },
        methods: {
            scrollHandler: throttle(function () {
                if (this.down) return;
                if(this.$refs.scrollView.scrollTop + this.$refs.scrollView.clientHeight === this.$refs.scrollView.scrollHeight){
                    try {
                        this.$emit('ToTheBottom')
                    }catch (e) {console.log(e)}
                }
                this.yTop = this.scrollView.scrollTop / this.viewWrap.offsetHeight * 100;
                this.xLeft = this.scrollView.scrollLeft / this.viewWrap.offsetWidth * 100;

            },16),
            update() {
                this.yHeight = this.scrollWrap.offsetHeight >= this.viewWrap.scrollHeight ? 0 : this.scrollWrap.offsetHeight / this.viewWrap.scrollHeight * 100;
                this.xWidth = this.scrollWrap.offsetWidth >= this.viewWrap.scrollWidth ? 0 : this.scrollWrap.offsetWidth / this.viewWrap.scrollWidth * 100;
            },
        },
        beforeDestroy() {

        }
    }
</script>

<style lang="scss" scoped>
    .scroll-wrap {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;

        &:hover .scroll-bar-y, &:hover .scroll-bar-x {
            transform: translateZ(0);
            opacity: 0.6;
        }

        > .scroll-view {
            margin-bottom: -17px;
            margin-right: -17px;
            height: calc(100% + 17px);
            width: calc(100% + 17px);
            overflow: scroll;

            > .view-wrap {
                width: 100%;
                height: 100%;
            }
        }

        > .scroll-bar-y {
            position: absolute;
            top: 0;
            right: 0;
            width: 4px;
            height: 100%;
            border-radius: 10px;
            background: #9e9e9e;
            transition: opacity 0.3s linear 1s,width 0.3s linear 1s;
            /*transform: translateZ(0);*/
            opacity: 0.6;
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;

            &:hover, &.ismove {
                width: 10px;
                opacity: 1;
                transition: width 0.01s linear;
            }
        }

        > .scroll-bar-x {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 4px;
            background: #9e9e9e;
            transition: opacity 0.3s linear,height 0.3s linear;
            /*transform: translateZ(0);*/
            border-radius: 10px;
            opacity: 0.6;
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;

            &:hover, &.ismove {
                height: 10px;
                opacity: 1;
                transition: height 0.01s linear;
            }
        }
    }
</style>
